<template>
    <i18n
        keypath="registration.privacy_consent_label"
        tag="p"
        class="consent-notice"
    >
        <template #termsOfUse>
            <ThLink
                :to="routes.page('terms')"
                target="_blank"
                :aria-label="`${t('registration.terms_of_use')} - opens in a new tab`"
            >
                {{ t('registration.terms_of_use') }}
            </ThLink>
        </template>

        <template #privacyPolicy>
            <ThLink
                :to="routes.page('privacy')"
                target="_blank"
                :aria-label="`${t('registration.privacy_policy')} - opens in a new tab`"
            >
                {{ t('registration.privacy_policy') }}
            </ThLink>
        </template>

        <template #cookiePolicy>
            <ThLink
                :to="routes.page('cookies')"
                target="_blank"
                :aria-label="`${t('registration.cookie_policy')} - opens in a new tab`"
            >
                {{ t('registration.cookie_policy') }}
            </ThLink>
        </template>
    </i18n>
</template>

<script setup lang="ts">
import { useRoutes } from '@/router/routes'
import { useI18n } from 'vue-i18n'

import ThLink from '@/components/ui/buttons/ThLink.vue'

const routes = useRoutes()
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.consent-notice {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    border-top: var(--border);
    background-color: $white;
    font-family: $sectra-font-stack;
    font-style: normal;
    font-weight: 400;
    color: $slate;
    font-size: 0.75rem;
    line-height: 1.4em;
    cursor: default;
    padding: 10px 20px;
    text-align: center;

    @include min-width(768) {
        padding: 20px 40px;
    }

    a {
        color: $blue;
        cursor: pointer;
    }
}
</style>
